import React from 'react'

import { Animation } from '@yapay/react-components'
import { Dialog, Box, Typography, Button } from '@material-ui/core'

const ModalSuccess = ({ open, onClose, children = 'Sucesso' }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width={{ sm: 560 }}
        p={4}
      >
        <Box>
          <Animation animation="success" size="normal" />
        </Box>
        <Box mt={6}>
          <Typography variant="h4" align="center" color="primary">
            {children}
          </Typography>
        </Box>
        <Box width={160} mt={8}>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            size="large"
            fullWidth
            onClick={() => onClose()}
          >
            OK
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}

export default ModalSuccess
